// Function to setup complementary color handlers
function setupComplementaryColorHandlers() {
  // Find all complementary color inputs
  const complementaryInputs = document.querySelectorAll('input[data-complementary-color="true"]');
  
  complementaryInputs.forEach(input => {
    // Add click handler to the label since the input is disabled
    const label = input.closest('label');
    const isOutOfStock = label.classList.contains('variant-option__button-label--out-of-stock');
    const url = input.getAttribute('data-connected-product-url');
    
    if (label) {
      // Remove any existing event listeners first
      label.removeEventListener('click', handleComplementaryColorClick);
      
      // Add new click handler
      label.addEventListener('click', handleComplementaryColorClick);
      
      // Also add onclick attribute as backup
      label.onclick = function(event) {
        event.preventDefault();
        event.stopPropagation();
        handleComplementaryColorSelection(input);
        return false;
      };
      
      // Add direct click handler to the input as well
      input.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        handleComplementaryColorSelection(input);
        return false;
      });
      
      // Add click handler to the text span as well
      const textSpan = label.querySelector('.variant-option__button-label__text');
      if (textSpan) {
        textSpan.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          handleComplementaryColorSelection(input);
          return false;
        });
        
        textSpan.onclick = function(event) {
          event.preventDefault();
          event.stopPropagation();
          handleComplementaryColorSelection(input);
          return false;
        };
      }
    }
    
    // Also handle change event as backup
    input.addEventListener('change', (event) => {
      if (event.target.checked) {
        handleComplementaryColorSelection(event.target);
      }
    });
  });
}

// Separate function for click handling
function handleComplementaryColorClick(event) {
  const input = event.target.closest('label')?.querySelector('input[data-complementary-color="true"]');
  if (input) {
    event.preventDefault();
    event.stopPropagation();
    handleComplementaryColorSelection(input);
  }
}

// Function to handle complementary color selection
function handleComplementaryColorSelection(input) {
  const colorValue = input.value;
  const connectedProductUrl = input.getAttribute('data-connected-product-url');
  
  if (!connectedProductUrl) {
    return;
  }
  
  // Redirect to the connected product
  window.location.href = connectedProductUrl;
}

// Event delegation approach - listen for clicks on the document (capture phase)
document.addEventListener('click', function(event) {
  // Check if click is on a fieldset (variant picker)
  if (event.target.tagName === 'FIELDSET' && event.target.classList.contains('variant-option')) {
    // Get the click coordinates relative to the fieldset
    const rect = event.target.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    
    // Find the complementary label at those coordinates
    const complementaryLabel = event.target.querySelector('label.variant-option__button-label--complementary');
    if (complementaryLabel) {
      const labelRect = complementaryLabel.getBoundingClientRect();
      const fieldsetRect = event.target.getBoundingClientRect();
      const labelX = labelRect.left - fieldsetRect.left;
      const labelY = labelRect.top - fieldsetRect.top;
      const labelWidth = labelRect.width;
      const labelHeight = labelRect.height;
      
      // Check if click is within the complementary label bounds
      if (x >= labelX && x <= labelX + labelWidth && y >= labelY && y <= labelY + labelHeight) {
        const complementaryInput = complementaryLabel.querySelector('input[data-complementary-color="true"]');
        if (complementaryInput) {
          event.preventDefault();
          event.stopPropagation();
          handleComplementaryColorSelection(complementaryInput);
          return false;
        }
      }
    }
  }
  
  // Original logic for direct clicks
  const complementaryInput = event.target.closest('label')?.querySelector('input[data-complementary-color="true"]');
  if (complementaryInput) {
    event.preventDefault();
    event.stopPropagation();
    handleComplementaryColorSelection(complementaryInput);
    return false;
  }
}, true); // Use capture phase to catch events before other listeners

// Also try mousedown in capture phase
document.addEventListener('mousedown', function(event) {
  const complementaryInput = event.target.closest('label')?.querySelector('input[data-complementary-color="true"]');
  if (complementaryInput) {
    event.preventDefault();
    event.stopPropagation();
    handleComplementaryColorSelection(complementaryInput);
    return false;
  }
}, true); // Use capture phase

// Also listen for mousedown events as backup
document.addEventListener('mousedown', function(event) {
  const complementaryInput = event.target.closest('label')?.querySelector('input[data-complementary-color="true"]');
  if (complementaryInput) {
    event.preventDefault();
    event.stopPropagation();
    handleComplementaryColorSelection(complementaryInput);
    return false;
  }
});

// Try immediate execution first
setupComplementaryColorHandlers();

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  setupComplementaryColorHandlers();
});

// Also try to initialize after a short delay to ensure all elements are rendered
setTimeout(() => {
  setupComplementaryColorHandlers();
}, 1000);

// Try again after a longer delay
setTimeout(() => {
  setupComplementaryColorHandlers();
}, 3000);